module.exports = __webpack_public_path__ + "img/wsd-icon-1@2x.e42fd57e.png";